module.exports = __webpack_public_path__ + "astra.png?31c6e88a929d67dd3a78344a450d7741";